<div class="metering-point-item__logical-wrapper">
  <div>
    <h2 class="h3">{{'metering.item.logical.title'|translate}}</h2>
  </div>

  <div>
    <div class="sxl-container">
      <div class="sxl-item sxl-item--4" *ngFor="let meteringPoint of meteringPoint.containedMeteringPoints">
        <article class="sx-metering-point" [ngClass]="{'selected': meteringPoint.selected}">
          <header class="sx-metering-point__header sx-metering-point__content">
            <h3 class="sx-metering-point__heading">{{meteringPoint.name}}</h3>
            <div class="sxh-text-light">{{'meteringpoints.card.id' | translate}} {{meteringPoint.id}}</div>
          </header>
          <div class="sx-metering-point__content">
            <div class="sx-metering-point__row">
              <div class="sx-metering-point__row-icon">
                <svg class="sxh-icon-big">
                  <use xlink:href="#sx-position" href="#sx-position" />
                </svg>
              </div>
              <div class="sx-metering-point__row-fragment">
                {{meteringPoint.addresses[0]!.street}} {{meteringPoint.addresses[0]!.streetNo}}
                <br /> {{meteringPoint.addresses[0]!.zip}} {{meteringPoint.addresses[0]!.city | titlecase}}
              </div>
            </div>
            <div class="sx-metering-point__row" *ngIf="meteringPoint.disruptionInfo">
              <ng-container *ngIf="meteringPoint.disruptionInfo.isPlanned">
                <div matTooltip="{{'disruptions.planned_tooltip' | translate}}" matTooltipClass="sx-metering-point__tooltip">
                  <div class="sxl-flex">
                    <div class="sx-metering-point__row-icon">
                      <svg class="sx-metering-point__planned-icon">
                        <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                      </svg>
                    </div>
                    <div class="sx-metering-point__row-fragment">
                      <span>{{ "disruptions.ongoing-planned-disruption" | translate }}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!meteringPoint.disruptionInfo.isPlanned">
                <div matTooltip="{{'disruptions.planned_tooltip' | translate}}" matTooltipClass="sx-metering-point__tooltip">
                  <div class="sxl-flex">
                    <div class="sx-metering-point__row-icon">
                      <svg class="sx-metering-point__unplanned-icon">
                        <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                      </svg>
                    </div>
                    <div class="sx-metering-point__row-fragment">
                      <span>{{ "disruptions.ongoing-unplanned-disruption" | translate }}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="sx-metering-point__chip-wrapper sxh-horizontal-stack-tiny">
              <div class="sx-chip sx-chip--blue" *ngIf="meteringPoint.hasIntelligy">{{'meteringpoints.card.hasIntelligy'
                | translate}}
              </div>
              <div class="sx-chip sx-chip--magenta" *ngIf="meteringPoint.hasFunctionControl">
                {{'meteringpoints.card.functionControl' | translate}}
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</div>
